// src/components/Legal/Privacy.js
import React from 'react';
import styles from './Legal.module.css';

const Privacy = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last Updated: February 22, 2024</p>

        <section className={styles.section}>
          <h2>1. Information We Collect</h2>
          <p>We collect information that you provide directly to us, including:</p>
          <ul>
            <li>Name and contact information</li>
            <li>Communication preferences</li>
            <li>Information about your business needs</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Communicate with you about our products and services</li>
            <li>Respond to your inquiries and requests</li>
            <li>Send you technical notices and support messages</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>3. Information Sharing</h2>
          <p>We do not sell or rent your personal information to third parties. We may share your information with:</p>
          <ul>
            <li>Service providers who assist in our operations</li>
            <li>Professional advisers and auditors</li>
            <li>Law enforcement when required by law</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>4. Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal information.</p>
        </section>

        <section className={styles.section}>
          <h2>5. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p>Email: contact@teezash.com</p>
          <p>Phone: 09337813196</p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;